import React from "react";
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MbpAthnUi from "Utils/MbpAthn";
import MembOtpRegScrtApi from "Apis/MembOtpRegScrtApi";
import MgpStore from "Stores/Store";
import { Helmet } from "react-helmet-async";
import TrmsCtxtInqApi from "Apis/TrmsCtxtInqApi";


const MembEmlChngUi = () => {
    const langData:any = useOutletContext();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [otpRegYn,setotpRegYn] = useState<any>();
    
    const [emlAthnPrpsCd] =useState("EML_CHNG");
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (670/2));
    const EmlAthnPopFunc = (e:any)=>{
        window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
    }
    useEffect(()=>{
        MembOtpRegChkApi()
        .then((resp) => {
            setotpRegYn(resp.apiBody);
        })
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                if(resp.apiHdr.code == "ATHN0000") {

                        navigate("/MyPage/EmlChngInput");
                }
            });
        }
        window.kmcRespFunc = kmcRespFunc;
        const emlAthnRespFunc =() => {
            return navigate("/MyPage/EmlChngInput");
        }
        window.emlAthnRespFunc = emlAthnRespFunc;
        
    },[]);
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div className="myPageSubCtxtWrap">
                <img className="otpImg" src={process.env.PUBLIC_URL+"/images/Mypage/OtpIcon.png"} alt="" />
                {/* otp 사용 여부 */}
                <div className="otpTxtWrap">
                    <p className="myPageCtxtTitl myPageEmlChngTitl">{langData&&langData.MYPAGE_MENU_EML_CHNG_BTN_00}</p>
                    <p className="activeText myPageEmlChngActiveText">{langData&&langData.MYPAGE_EML_ATHN_PAGE_TITL_00}</p>
                    <div className="myPageEmlChngMbpAthn">
                        {MgpStore.getState().IdntMthdCdState.IdntMthdCd === "MBP"?
                            <MbpAthnUi  athnPrpsCd='EML_CHNG'AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}/>
                            :
                            <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=EML_CHNG_ATHN&lang=' +MgpStore.getState().LangSetState.Lang}`)}>
                                <span>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</span>
                                {/* 인증하기 */}
                            </button>
                        }
                    </div>
                </div>
            </div> 
        </div>
        </>
    )
}

export default MembEmlChngUi;